import { render, staticRenderFns } from "./SelectableYearFirmwideEmissionByProductFamily.vue?vue&type=template&id=3356b8fa"
import script from "./SelectableYearFirmwideEmissionByProductFamily.vue?vue&type=script&lang=js"
export * from "./SelectableYearFirmwideEmissionByProductFamily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports